import {
  ehEnderecoDoApp,
  paraInterno,
} from 'dashboard/routes/enderecos/traducao';
import { contaPrincipal } from 'dashboard/routes/enderecos/conta';

// ALERTA DO SISTEMA NO SINO (23/09/2026) — para onde o clique leva.
//
// Os alertas da equipe saíam pelo WhatsApp do escritório; agora chegam como
// notificação (`alerta_urgente` / `alerta_do_sistema`) com o link no `meta`
// (a conversa, a caixa, a página). O "ator" da notificação é o registro do
// alerta, que não é uma tela — por isso o destino vem do link, não do ator.
//
// Link do próprio advup navega sem recarregar; link de fora abre outra aba.
// Ver Lumos::AlertDispatcher e docs/AVISOS-DA-EQUIPE.md.
export const TIPOS_DE_ALERTA = ['alerta_urgente', 'alerta_do_sistema'];

export const ehAlerta = tipo => TIPOS_DE_ALERTA.includes(tipo);

export const destinoDoAlerta = link => {
  if (!link) return null;
  try {
    const url = new URL(link, window.location.origin);
    // Endereço antigo (`/app/…`) ou limpo (`/processos/27`, 06/10/2026): o
    // roteador só conhece o interno, então o limpo é traduzido.
    if (
      url.origin === window.location.origin &&
      ehEnderecoDoApp(url.pathname)
    ) {
      return {
        interno: paraInterno(
          `${url.pathname}${url.search}${url.hash}`,
          contaPrincipal()
        ),
      };
    }
    return { externo: url.href };
  } catch {
    return null;
  }
};

// Abre o destino do alerta. Sem link, fica onde está (o texto já foi lido).
export const abrirAlerta = (router, notification) => {
  const destino = destinoDoAlerta(notification?.meta?.link);
  if (destino?.interno) router.push(destino.interno);
  else if (destino?.externo) window.open(destino.externo, '_blank', 'noopener');
};
